import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import homeImg1 from '../../assets/img/menu/home-1.jpg';
import homeImg2 from '../../assets/img/menu/home-2.jpg';
import homeImg3 from '../../assets/img/menu/home-3.jpg';
import homeImg4 from '../../assets/img/menu/home-4.jpg';
import homeImg5 from '../../assets/img/menu/home-5.jpg';
import homeImg6 from '../../assets/img/menu/home-6.jpg';

const MenuItemsOnePage = (props) => {
  const { onePageStyle, isMobileMenu } = props;
  const [home, setHome] = useState(false);
  const [isActive, setIsActive] = useState('home');

  const openMobileMenu = (menu) => {
    if (menu === 'home') {
      setHome(!home);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsActive('home');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsActive(id);
  };

  const handleClick = (e) => {
    if (!isMobileMenu) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      e.preventDefault();
    }
  };

  const onePageHomeMenu = (
    <li
      className={
        isActive === 'home'
          ? 'has-dropdown p-static active'
          : 'has-dropdown p-static'
      }
    >
      <Link
        to="#"
        className={`${home ? 'expanded' : ''}`}
        onClick={handleClick}
      >
        بيت
        <button
          className={`${
            home ? 'dropdown-toggle-btn dropdown-opened' : 'dropdown-toggle-btn'
          } d-xl-none `}
          onClick={() => {
            openMobileMenu('home');
          }}
        >
          <i className="fal fa-angle-right"></i>
        </button>
      </Link>
      <div
        className={
          home
            ? 'it-submenu submenu has-home-img d-block'
            : 'it-submenu submenu has-home-img'
        }
      >
        <div className="row gx-6 row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-6">
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg1} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/">Home 01</Link>
              </h4>
            </div>
          </div>
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg2} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/home-2">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-2-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/home-2">Home 02</Link>
              </h4>
            </div>
          </div>
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg3} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/home-3">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-3-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/home-3">Home 03</Link>
              </h4>
            </div>
          </div>
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg4} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/home-4">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-4-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/home-4">Home 04</Link>
              </h4>
            </div>
          </div>
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg5} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/home-5">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-5-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/home-5">Home 05</Link>
              </h4>
            </div>
          </div>
          <div className="col home-img">
            <div className="home-img-thumb mb-15">
              <img src={homeImg6} alt="" />
              <div className="home-img-btn">
                <Link className="it-btn-sm" to="/home-6">
                  <Button btnText="Multi Page" />
                </Link>
                <Link className="it-btn-sm" to="/home-6-one-page">
                  <Button btnText="One Page" />
                </Link>
              </div>
            </div>
            <div className="home-img-content text-center">
              <h4 className="home-img-title">
                <Link to="/home-6">Home 06</Link>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </li>
  );

  return (
    <>
      {onePageStyle === 'onePage1' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-about' ? 'active' : ''}>
            <Link to="#it-about" onClick={() => scrollToSection('it-about')}>
              <span>معلومات عنا</span>
            </Link>
          </li>
          <li className={isActive === 'it-service' ? 'active' : ''}>
            <Link
              to="#it-service"
              onClick={() => scrollToSection('it-service')}
            >
              <span>خدمات</span>
            </Link>
          </li>
          <li className={isActive === 'it-choose' ? 'active' : ''}>
            <Link to="#it-choose" onClick={() => scrollToSection('it-choose')}>
              <span>يختار</span>
            </Link>
          </li>
          <li className={isActive === 'it-team' ? 'active' : ''}>
            <Link to="#it-team" onClick={() => scrollToSection('it-team')}>
              <span>فريق</span>
            </Link>
          </li>
          <li className={isActive === 'it-contact' ? 'active' : ''}>
            <Link
              to="#it-contact"
              onClick={() => scrollToSection('it-contact')}
            >
              <span>اتصال</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
        </ul>
      ) : onePageStyle === 'onePage2' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-about' ? 'active' : ''}>
            <Link to="#it-about" onClick={() => scrollToSection('it-about')}>
              <span>معلومات عنا</span>
            </Link>
          </li>
          <li className={isActive === 'it-service' ? 'active' : ''}>
            <Link
              to="#it-service"
              onClick={() => scrollToSection('it-service')}
            >
              <span>خدمات</span>
            </Link>
          </li>
          <li className={isActive === 'it-appointment' ? 'active' : ''}>
            <Link
              to="#it-appointment"
              onClick={() => scrollToSection('it-appointment')}
            >
              <span>ميعاد</span>
            </Link>
          </li>
          <li className={isActive === 'it-team' ? 'active' : ''}>
            <Link to="#it-team" onClick={() => scrollToSection('it-team')}>
              <span>فريق</span>
            </Link>
          </li>
          <li className={isActive === 'it-price' ? 'active' : ''}>
            <Link to="#it-price" onClick={() => scrollToSection('it-price')}>
              <span>سعر</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
        </ul>
      ) : onePageStyle === 'onePage3' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-about' ? 'active' : ''}>
            <Link to="#it-about" onClick={() => scrollToSection('it-about')}>
              <span>معلومات عنا</span>
            </Link>
          </li>
          <li className={isActive === 'it-choose' ? 'active' : ''}>
            <Link to="#it-choose" onClick={() => scrollToSection('it-choose')}>
              <span>يختار</span>
            </Link>
          </li>
          <li className={isActive === 'it-contact' ? 'active' : ''}>
            <Link
              to="#it-contact"
              onClick={() => scrollToSection('it-contact')}
            >
              <span>اتصال</span>
            </Link>
          </li>
          <li className={isActive === 'it-team' ? 'active' : ''}>
            <Link to="#it-team" onClick={() => scrollToSection('it-team')}>
              <span>فريق</span>
            </Link>
          </li>
          <li className={isActive === 'it-testimonial' ? 'active' : ''}>
            <Link
              to="#it-testimonial"
              onClick={() => scrollToSection('it-testimonial')}
            >
              <span>شهادة</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
        </ul>
      ) : onePageStyle === 'onePage4' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-about' ? 'active' : ''}>
            <Link to="#it-about" onClick={() => scrollToSection('it-about')}>
              <span>معلومات عنا</span>
            </Link>
          </li>
          <li className={isActive === 'it-service' ? 'active' : ''}>
            <Link
              to="#it-service"
              onClick={() => scrollToSection('it-service')}
            >
              <span>خدمات</span>
            </Link>
          </li>
          <li className={isActive === 'it-choose' ? 'active' : ''}>
            <Link to="#it-choose" onClick={() => scrollToSection('it-choose')}>
              <span>يختار</span>
            </Link>
          </li>
          <li className={isActive === 'it-team' ? 'active' : ''}>
            <Link to="#it-team" onClick={() => scrollToSection('it-team')}>
              <span>فريق</span>
            </Link>
          </li>
          <li className={isActive === 'it-testimonial' ? 'active' : ''}>
            <Link
              to="#it-testimonial"
              onClick={() => scrollToSection('it-testimonial')}
            >
              <span>شهادة</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
        </ul>
      ) : onePageStyle === 'onePage5' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-about' ? 'active' : ''}>
            <Link to="#it-about" onClick={() => scrollToSection('it-about')}>
              <span>معلومات عنا</span>
            </Link>
          </li>
          <li className={isActive === 'it-service' ? 'active' : ''}>
            <Link
              to="#it-service"
              onClick={() => scrollToSection('it-service')}
            >
              <span>خدمات</span>
            </Link>
          </li>
          <li className={isActive === 'it-choose' ? 'active' : ''}>
            <Link to="#it-choose" onClick={() => scrollToSection('it-choose')}>
              <span>يختار</span>
            </Link>
          </li>
          <li className={isActive === 'it-contact' ? 'active' : ''}>
            <Link
              to="#it-contact"
              onClick={() => scrollToSection('it-contact')}
            >
              <span>اتصال</span>
            </Link>
          </li>
          <li className={isActive === 'it-testimonial' ? 'active' : ''}>
            <Link
              to="#it-testimonial"
              onClick={() => scrollToSection('it-testimonial')}
            >
              <span>شهادة</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
        </ul>
      ) : onePageStyle === 'onePage6' ? (
        <ul className="it-onepage-menu">
          {onePageHomeMenu}
          <li className={isActive === 'it-category' ? 'active' : ''}>
            <Link
              to="#it-category"
              onClick={() => scrollToSection('it-category')}
            >
              <span>فئات</span>
            </Link>
          </li>
          <li className={isActive === 'it-shop' ? 'active' : ''}>
            <Link to="#it-shop" onClick={() => scrollToSection('it-shop')}>
              <span>محل</span>
            </Link>
          </li>
          <li className={isActive === 'it-discount' ? 'active' : ''}>
            <Link
              to="#it-discount"
              onClick={() => scrollToSection('it-discount')}
            >
              <span>تخفيض</span>
            </Link>
          </li>
          <li className={isActive === 'it-testimonial' ? 'active' : ''}>
            <Link
              to="#it-testimonial"
              onClick={() => scrollToSection('it-testimonial')}
            >
              <span>شهادة</span>
            </Link>
          </li>
          <li className={isActive === 'it-blog' ? 'active' : ''}>
            <Link to="#it-blog" onClick={() => scrollToSection('it-blog')}>
              <span>مدونة</span>
            </Link>
          </li>
          <li className={isActive === 'it-brand' ? 'active' : ''}>
            <Link to="#it-brand" onClick={() => scrollToSection('it-brand')}>
              <span>ماركة</span>
            </Link>
          </li>
        </ul>
      ) : (
        <ul></ul>
      )}
    </>
  );
};

export default MenuItemsOnePage;
